import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/webapp/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/webapp/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/webapp/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Instrument_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"instrumentSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/webapp/app/globals.css");
